export default "__VITE_ASSET__DOcUWyY3__"